import { LoanMultiplier, LoopscalePointsAction, RewardPointsPerSecond } from "@bridgesplit/abf-react";

export function getLoopscalePointsPerUnitTime(
    loopscalePointsAction: LoopscalePointsAction,
    identifier: string | undefined,
    estimateSeconds: number,
    totalPrincipalAmountUsd: number | undefined,

    rewardPointsPerSecond: RewardPointsPerSecond | undefined,
    loanMultipliers: LoanMultiplier | undefined
) {
    const pointPerSecond = rewardPointsPerSecond?.[loopscalePointsAction]?.pointsPerSecond;
    const loanMultiplier = loanMultipliers?.[identifier ?? ""]?.[loopscalePointsAction]?.multiplier ?? 1;

    const pointsPerUnitTime =
        (pointPerSecond ?? 0) * (loanMultiplier ?? 1) * (totalPrincipalAmountUsd ?? 0) * estimateSeconds;
    return pointsPerUnitTime;
}
